import { svgCursorStyle } from './svgCursorStyle';

const OUTLINED_ARROWS_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M12 2v20M2 12h20M5 9l-3 3 3 3M19 9l3 3-3 3M9 5l3-3 3 3M9 19l3 3 3-3"/></svg>';
const FILLED_ARROWS_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M12 2v20M2 12h20M5 9l-3 3 3 3M19 9l3 3-3 3M9 5l3-3 3 3M9 19l3 3 3-3"/></svg>';

/** Outlined four-way arrows: a drag would translate. */
export const OUTLINED_ARROWS_CURSOR = svgCursorStyle(
    OUTLINED_ARROWS_SVG,
    { x: 12, y: 12 },
    'move'
);
/** Filled four-way arrows: a translation is in progress. */
export const FILLED_ARROWS_CURSOR = svgCursorStyle(
    FILLED_ARROWS_SVG,
    { x: 12, y: 12 },
    'move'
);
